import { enhancedFetch, EnhancedFetchError, ssrBuilder } from 'journey-ui'
import { NextPageContext } from 'next'
import React from 'react'
import { AppPage } from '../components/AppPage'
import { BrandHeader } from '../components/BrandHeader'
import { redirectIfNoBrand } from '../helpers'

type Props = {
  brand: Brand
}

const PrivacyPage: React.FC<Props> = ({ brand }) => (
  <AppPage brand={brand} title="Privacy" description="Learn more about our privacy policy." fullScreen>
    <BrandHeader className="h-40">
      <span className="z-20">Privacy Policy</span>
    </BrandHeader>

    <div className="p-2 space-y-3">
      <p className="font-bold">Pizzamico, LLC Privacy Policy</p>
      <p>
        Your privacy is important to us. It is Pizzamico, LLC's policy to respect your privacy
        regarding any information we may collect from you across our website, https://pizzamico.com,
        and other sites we own and operate.
      </p>

      <p>
        We only ask for personal information when we truly need it to provide a service to you.
        We collect it by fair and lawful means, with your knowledge and consent. We also let you know why we’re collecting it and how it will be used.
      </p>

      <p>
        We only retain collected information for as long as necessary to provide you with your requested service.
        What data we store, we’ll protect within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.
      </p>

      <p>
        We don’t share any personally identifying information publicly or with third-parties, except when required to by law.
      </p>

      <p>
        Our website may link to external sites that are not operated by us.
        Please be aware that we have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.
      </p>

      <p>
        You are free to refuse our request for your personal information, with the understanding that we may be unable to provide you with some of your desired services.
      </p>

      <p>
        Your continued use of our website will be regarded as acceptance of our practices around privacy and personal information.
        If you have any questions about how we handle user data and personal information, feel free to contact us.
      </p>

      <p>This policy is effective as of 1 January 2017.</p>
    </div>
  </AppPage>
)

// noinspection JSUnusedGlobalSymbols (PHPStorm doesn't detect NextJS's pages)
export default PrivacyPage

export async function getServerSideProps(ctx) {
  return ssrBuilder(ctx)
    .setProp('brand', (fetcher) => fetcher(`/api/brand/${ctx.req.headers.host}`))
    .onError(redirectIfNoBrand)
    .get()
}
